import * as React from "react";
import { FieldValueDouble } from "typings";
import { BaseFieldEditor } from "./helper";
import NumberTextField from "~/components/baseComponent/NumberTextField";
import styled from "styled-components";
import { Label } from "office-ui-fabric-react/lib/Label";

export interface Props extends BaseFieldEditor
{
    value: FieldValueDouble;
    placeholder?: string;
}

class Double extends React.Component<Props>
{
    onChange = (value: number) =>
    {
        const fieldValue: FieldValueDouble = {...this.props.value, value};
        this.props.onValueChange(fieldValue);
    }
    render()
    {
        const { value } = this.props;
        const unit = this.props.field.unit;        
        const unitLabel = unit ? <Label>{this.props.field.unit}</Label> : null;

        return (
            <NumbericStyle>
                <NumberTextField 
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder} 
                    value={value && value.value || 0} 
                    onChange={this.onChange}
                     />{unitLabel}
            </NumbericStyle>
        );
    }
}


const NumbericStyle = styled.div`

    display: flex;
    label{
        margin-left: 10px;
    }
`;

export default Double;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Double.tsx